import React from 'react';
import style from './AboutMeSection.module.scss';

const AboutMeSection = () => {
  return (
    <div className={style.container} id="about">
      <h1>Su di me</h1>
      <p>
        Mi chiamo Dinara Valiyeva, sono la fondatrice di NARA Milano Beauty Space, cosmetologa
        certificata, formatrice e specialista lash & brow con oltre 15 anni di esperienza nel
        settore della bellezza e del benessere. La mia carriera ha avuto inizio a Mosca, dove ho
        studiato con rinomati professionisti del settore e sono stata tra le prime in Russia e
        Kazakhstan a perfezionare la tecnica dell’extension ciglia. Successivamente ho completato la
        mia formazione presso una scuola italiana di estetica, acquisendo una visione europea della
        cura della pelle e della bellezza naturale. Oggi mi dedico a trattamenti estetici avanzati
        per il viso, sia manuali che strumentali, tra cui Hydrafacial, protocolli anti-età,
        rigenerazione cutanea post-stress e post-esposizione solare, idratazione profonda e
        tonificazione della pelle. Sono costantemente impegnata nell’aggiornamento professionale,
        nello studio di nuove metodologie e nell’integrazione delle più recenti tendenze
        internazionali nell’ambito della cosmetologia. In qualità di formatrice, trasmetto le mie
        competenze a professionisti del settore, insegnando le tecniche di extension e laminazione
        di ciglia e sopracciglia, oltre all’equilibrio tra estetica avanzata e cosmetologia moderna.
        Il mio approccio si fonda su un principio chiaro: valorizzare la bellezza naturale
        attraverso la cura, la competenza e l’armonia, per ottenere una pelle sana, luminosa e
        autentica, senza eccessi né artifici.
      </p>
    </div>
  );
};

export default AboutMeSection;
